/* eslint-disable react/jsx-indent-props */
import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import { observer } from "mobx-react-lite";
import { useStores } from "../use.store";
import { shallowEqual, useSelector } from "react-redux";
import axios from "axios";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { informationID } from "../utils/constants";
import getInfoHeadIcon from "../assets/images/get-info-head.png";
import arrowRightIcon from "../assets/images/arrow-right.svg";

const GetInfo = observer(() => {
  const { generalStore } = useStores();
  const [filteredData, setFilteredData] = useState([]);

  const { config } = useSelector((state) => {
    return {
      config: state.auth.config,
    };
  }, shallowEqual);

  useEffect(() => {
    generalStore.activePage = "get-info";
    const filter = generalStore.information.filter(
      (item) => item.categoryId === informationID.getInfoDetail
    );
    setFilteredData(filter);
  }, []);

  const handleAnalytics = (label, callback) => {
    // axios
    //   .post(`${config.baseUrl}/analytic/application`, {
    //     site: config.siteId,
    //     device: config.map.deviceId,
    //     type: "gethelp",
    //     action: "select",
    //     label: label,
    //   })
    //   .finally(callback);
  };

  const listMenu = [
    {
      name: "Operating Hours of State Courts",
      image: "clock",
      slug: "operating-hours",
      informationId: "672da8d0f5c87d7d52b148a0",
    },
    {
      name: "Contact Details",
      image: "contact",
      slug: "contact-details",
      informationId: "6731c4db550562c63c031941",
    },
    {
      name: "Using The Right Lobby and Escalators",
      image: "escalator",
      slug: "lobby-operating-guide",
      informationId: "6731c4cf550562c63c03193a",
    },
  ];

  const navigate = useHistory();

  return (
    <Layout>
      <div className="h-full w-full flex flex-col">
        <div className="h-[70px] md:h-[80px] w-full bg-bgColor flex justify-start items-center p-4 md:px-28">
          <h1 className="text-xl md:text-[40px] text-white font-bold">
            More Information
          </h1>
        </div>
        <div className="bg-[#e0dcd8] flex flex-row justify-between h-[120px] md:h-[160px]">
          <div className="px-4 md:px-28 flex flex-col justify-center md:items-center">
            <div class="hidden md:flex flex-col gap-2">
              <div className="flex flex-row">
                <p className="font-bold text-xl md:text-[40px]">About Us</p>
              </div>

              <p className="font-normal text-base text-textSecondary">
                {filteredData[0] &&
                  filteredData[0].description &&
                  filteredData[0].description}
              </p>
            </div>
            <div class="block md:hidden flex-col">
              <p className="font-bold text-xl md:text-[40px]">About Us</p>
              <p className="font-normal text-xs text-textSecondary">
                {filteredData[0] &&
                  filteredData[0].description &&
                  filteredData[0].description}
              </p>
            </div>
          </div>
          <div className="relative h-[120px] md:h-[160px]">
            <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-[#e0dcd8] to-transparent z-10 "></div>
            <img
              src={getInfoHeadIcon}
              className="w-[140px] md:w-40 h-[120px] md:h-[160px]"
            />
          </div>
        </div>
        {/* body */}
        <div className="flex-grow w-full flex flex-col items-center overflow-y-scroll p-4 md:gap-6 md:py-6 bg-whiteBg md:px-28">
          {listMenu.map((e) => {
            return (
              <div
                onClick={() => {
                  navigate.push(`/get-info/${e.slug}`);
                }}
                key={e.slug}
                className=" w-full"
              >
                <div className="flex flex-row gap-4 bg-white p-5 rounded-md mb-4 items-center w-full md:h-[120px]">
                  <img
                    className="w-10 h-10"
                    src={require(`../assets/images/${e["image"]}.svg`)}
                  />
                  <div className="flex flex-row justify-between w-full">
                    <span className="text-sm md:text-2xl text-[#3D3D3D] ">
                      {e["name"]}
                    </span>
                    <img className="w-5 h-5" src={arrowRightIcon} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
});

export default GetInfo;
